/* Hero BOXR wordmark: invisible at the top, fading in steadily as the visitor scrolls. The letters are a window
   onto Miami at dusk (graded pink sky, teal palms; CC0 photo by Joe deSousa) with a pink/cyan neon edge that
   warms up with the scroll, and the photo drifts slightly inside the letters. */
(function () {
  var m = document.querySelector(".hero__mark"), h = document.querySelector(".hero");
  if (!m || !h) return;
  var svg = m.querySelector("svg"), NS = "http://www.w3.org/2000/svg", img = null;
  if (svg) {
    var small = window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
    var defs = document.createElementNS(NS, "defs"), pat = document.createElementNS(NS, "pattern");
    pat.setAttribute("id", "miami"); pat.setAttribute("patternUnits", "userSpaceOnUse");
    pat.setAttribute("x", "0"); pat.setAttribute("y", "0"); pat.setAttribute("width", "1692.4"); pat.setAttribute("height", "376.9");
    img = document.createElementNS(NS, "image");
    img.setAttribute("href", window.BX.base + "bx-miami-vice-band" + (small ? "-1200" : "") + ".jpg");
    img.setAttribute("x", "-60"); img.setAttribute("y", "-14"); img.setAttribute("width", "1812"); img.setAttribute("height", "405");
    img.setAttribute("preserveAspectRatio", "xMidYMid slice");
    pat.appendChild(img); defs.appendChild(pat); svg.insertBefore(defs, svg.firstChild); svg.setAttribute("fill", "url(#miami)");
  }
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var dist = 400;
  var measure = function () {
    var r = m.getBoundingClientRect(), top = r.top + window.scrollY, hdr = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--hdr")) || 64;
    dist = Math.max(110, Math.min(h.offsetHeight * 0.5, top - hdr + r.height * 0.6));
  };
  var raf = 0;
  var set = function () {
    raf = 0; measure(); var p = reduced ? 1 : Math.min(1, Math.max(0, window.scrollY / dist));
    m.style.setProperty("--mark-o", p.toFixed(3));
    m.style.setProperty("--glow", p.toFixed(3));
    if (img && !reduced) img.setAttribute("x", (-60 + 60 * p).toFixed(1));
  };
  window.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(set); }, { passive: true });
  window.addEventListener("resize", set); window.addEventListener("load", set);
  set();
})();
